<template>
  <div class="login-container">
    <h1 class="login-title">空想工作室</h1>
    <div class="login-area">
      <form class="login-form" @submit.prevent="login">
        <div class="login-content">
          <div class="login-box">
            <input type="email" id="email" required placeholder=" " class="login-input" v-model="email">
            <label for="email" class="login-label">邮箱</label>
            <i class="ri-mail-fill login-icon"></i>
          </div>
          <div class="login-box">
            <input :type="passwordType" id="password" required placeholder=" " class="login-input" v-model="password">
            <label for="password" class="login-label">密码</label>
            <i :class="passwordIcon" class="login-icon login-password" @click="togglePasswordVisibility"></i>
          </div>
        </div>
        <button type="submit" class="login-button">登录</button>
      </form>
      <p class="login-switch">
        还没有账号？
        <button @click="resetFields; $emit('switch-to-register')" class="switch-button">立即注册</button>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: '',
      password: '',
      passwordType: 'password',
      passwordIcon: 'ri-eye-off-fill',
    };
  },
  methods: {
    togglePasswordVisibility() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password';
      this.passwordIcon = this.passwordIcon === 'ri-eye-off-fill' ? 'ri-eye-fill' : 'ri-eye-off-fill';
    },
    login() {
      const adminEmail = 'admin@example.com';
      const adminPassword = 'admin123';

      if (this.email === adminEmail && this.password === adminPassword) {
        alert('管理员登录成功！');
        this.$emit('switch-to-management');
        return;
      }

      const users = JSON.parse(localStorage.getItem('users')) || [];
      const user = users.find(u => u.email === this.email && u.password === this.password);
      if (user) {
        alert('登录成功！');
        localStorage.setItem('isLoggedIn', 'true');
        localStorage.setItem('currentUser', JSON.stringify(user));
        window.location.href = './html/index.html';
      } else {
        alert('登录失败：邮箱或密码错误！');
      }
    },
    resetFields() {
      this.email = '';
      this.password = '';
    },
    setPageIcon() {
      const link = document.createElement('link');
      link.rel = 'icon';
      link.href = '/favicon.ico'; // 替换为你的图标路径
      document.head.appendChild(link);
    }
  },
  mounted() {
    this.setPageIcon();
    document.title = '登录 - 空想工作室';
    this.resetFields(); // 确保页面加载时清空输入框
  }
};
</script>

<style scoped>
.login-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.9); /* 半透明白色背景 */
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1); /* 添加阴影 */
  width: 100%;
  max-width: 400px;
}

.login-title {
  font-size: 2rem;
  margin-bottom: 2rem;
  color: #333;
}

.login-area {
  width: 100%;
}

.login-form {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.login-content {
  display: grid;
  gap: 1rem;
}

.login-box {
  position: relative;
  width: 100%;
}

.login-input {
  width: 365px;
  padding: 1rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1rem;
  transition: border-color 0.3s;
}

.login-input:focus {
  border-color: #007bff;
}

.login-label {
  position: absolute;
  top: 0.5rem;
  left: 1rem;
  transition: all 0.3s ease;
}

.login-input:focus + .login-label,
.login-input:not(:placeholder-shown) + .login-label {
  top: -1rem;
  font-size: 0.8rem;
  color: #007bff;
}

.login-icon {
  position: absolute;
  right: 1rem;
  top: 1rem;
  font-size: 1.2rem;
  color: #ccc;
}

.login-button {
  margin-top: 1rem;
  padding: 1rem;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  width: 100%;
}

.login-button:hover {
  background: #0056b3;
}

.login-switch {
  text-align: center;
  margin-top: 1rem;
}

.switch-button {
  background: none;
  border: none;
  color: #007bff;
  cursor: pointer;
  text-decoration: underline;
}
</style>
